import { IJsonQuery } from '../../utils/jsonQuery';
import { IApplicationState } from '../../types/redux';

export const selectJsonQuery = (state: IApplicationState): IJsonQuery => state.filters.jsonQuery;
